export default "__VITE_ASSET__D2ORWcIg__"